export class ODataSearchResponse<T> {
  public items: T[];
  public count: number | undefined;
  public error: any | undefined;
  public h_create_entity: string | undefined;
}
